import { NativeModules, Platform } from 'react-native'

interface DIAMediaPlaybackModuleInterface {
  startMediaPlayback: (title: string) => void
  stopMediaPlayback: () => void
}

const MediaPlaybackModule: DIAMediaPlaybackModuleInterface =
  NativeModules.DIAMediaPlaybackModule || {}

class MediaPlaybackService {
  private isAndroid = Platform.OS === 'android'

  startPlayback(title: string): void {
    if (!this.isAndroid) return

    try {
      MediaPlaybackModule.startMediaPlayback(title)
    } catch (_error) {
      // Silently fail on older Android versions or if module not available
    }
  }

  stopPlayback(): void {
    if (!this.isAndroid) return

    try {
      MediaPlaybackModule.stopMediaPlayback()
    } catch (_error) {
      // Silently fail
    }
  }
}

export default new MediaPlaybackService()
